import { render, staticRenderFns } from "./swap.vue?vue&type=template&id=b9a659d8&scoped=true&"
import script from "./swap.vue?vue&type=script&lang=js&"
export * from "./swap.vue?vue&type=script&lang=js&"
import style0 from "./swap.vue?vue&type=style&index=0&id=b9a659d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a659d8",
  null
  
)

export default component.exports